import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../../../hooks';
import { NAVBAR_FLOATING_ACTION_SIZE } from '../../../../Navbar.constants';
import { NavbarGlassView } from '../NavbarGlassView/NavbarGlassView';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingPrimaryNav = (props: Props) => {
  const { children, shadow } = props;

  const { minWidth } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerStyles = [styles.container, !minWidth.isMD && styles.containerSM];

  return (
    <NavbarGlassView shadow={shadow} style={containerStyles}>
      {children}
    </NavbarGlassView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    minHeight: NAVBAR_FLOATING_ACTION_SIZE,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['6'],
  },
  containerSM: {
    gap: theme.spacing['2'],
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  shadow?: boolean;
}>;
